// removed by extract-text-webpack-plugin
module.exports = {"horizontal-scroll-container":"horizontal-scroll-container___3U9Hs","horizontal-scroll":"horizontal-scroll___2q21p"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HorizontalScroll/index.modules.less
// module id = 731
// module chunks = 431